import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

const WordWrapEllipse = ({
  MaxWidth = "25ch",
  Text = "",
  isLeft = true,
  showTooltip = true,
  tooltipMaxWidth = "300px" // Change width as you like
}) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [Text, MaxWidth]);

  useEffect(() => {
    if (isOverflowing && isHovered && textRef.current) {
      const rect = textRef.current.getBoundingClientRect();

      // Position adjustment to prevent right overflow
      const spaceRight = window.innerWidth - rect.right;
      const leftPos =
        spaceRight < 200 // if less space → show on left side
          ? rect.left - 10
          : rect.right + 10;

      setTooltipPos({
        top: rect.top,
        left: leftPos,
      });
    }
  }, [isOverflowing, isHovered, isLeft]);

  return (
    <div
      style={{ display: "inline-block" }}
      {...(showTooltip && {
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false)
      })}
    >
      <div
        ref={textRef}
        style={{
          maxWidth: MaxWidth,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: isOverflowing ? "pointer" : "default",
        }}
      >
        {Text}
      </div>

      {isOverflowing &&
        isHovered &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              background: "#333",
              color: "#fff",
              padding: "6px 10px",
              borderRadius: "4px",
              fontSize: "12px",
              top: tooltipPos.top,
              left: tooltipPos.left,
              zIndex: 99999,

              // 👇 This makes text wrap instead of going outside
              whiteSpace: "normal",
              wordBreak: "break-word",
              maxWidth: tooltipMaxWidth,
            }}
          >
            {Text}
          </div>,
          document.body
        )}
    </div>
  );
};

export default WordWrapEllipse;
